import React, {Component} from 'react';
import Canada from '../assets/Canada.svg'
import US from '../assets/US.svg'

import {SplitButton} from 'react-bootstrap';
import  {MenuItem} from  'react-bootstrap';
import '../css/bootstrap-theme.min.css';
import '../css/bootstrap.min.css';

import '../css/Country.css';

class Country extends Component{
    constructor(props){
        super(props)

        this.handleLanguageClick = this.handleLanguageClick.bind(this);
        this.handleCountrySelect = this.handleCountrySelect.bind(this);
    }

    handleLanguageClick(e){
        var language
        language = e.target.getAttribute("data")
        this.props.setLanguage(language)

    }

    handleCountrySelect(e){
        var country
        country = e;
        this.props.setCountry(country)

    }

    render(){
        var language = this.props.Settings.language;
        var country = this.props.Settings.country;
        var english = {};
        var french = {};

        if(language === "en"){
            english = "language-active";
            french = "language-inactive";
        }else{
            french = "language-active";
            english = "language-inactive";

        }


        if(country === "CA"){
            return(
                <div className = "country-row">
                    <div className = "country-selector">
                        <SplitButton id = "select-country" bsStyle = "default" title = {
                            <img src={Canada} className ="country-image" alt="Canada"/>

                        }>
                            <MenuItem onSelect={this.handleCountrySelect} eventKey = "CA" ><img src = {Canada} className = "country-image" alt="CA"/></MenuItem>
                            <MenuItem onSelect={this.handleCountrySelect} eventKey = "US"><img src = {US} className = "country-image" alt="US"/></MenuItem>
                        </SplitButton>
                    </div>

                    <div className = "language-selector">
                        <div onClick = {this.handleLanguageClick} className = {english} data="en">EN</div>
                        <div className = "language-inactive"> &nbsp; / &nbsp; </div>
                        <div onClick = {this.handleLanguageClick} className = {french} data="fr" >FR</div>
                    </div>

                </div>

            )

        }

        return(
        <div className = "country-row">
            <div className = "country-selector">
                <SplitButton bsStyle = "default" id={"countrySplitButton"} title = {
                    <img src={US} className ="country-image" alt="Canada"/>

                }>
                    <MenuItem onSelect={this.handleCountrySelect} eventKey = "CA" ><img src = {Canada} className = "country-image" alt="CA"/></MenuItem>
                    <MenuItem onSelect={this.handleCountrySelect} eventKey = "US"><img src = {US} className = "country-image" alt="US"/></MenuItem>
                </SplitButton>
            </div>
        </div>


        )



    }

}

export default Country;


// WEBPACK FOOTER //
// ./src/components/Country.js